import React from "react";

function WarningButton({ type=null, disabled=false, children, onClick, className=null }) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={`
        bg-red-500 hover:bg-red-400
        text-white
        font-medium text-sm
        px-3 py-1.5
        border-0 rounded-lg
        shadow-[0_0_0_0.2rem_rgba(0,0,0,0.1)]
        hover:shadow-[0_0_0_0.2rem_rgba(0,0,0,0.2)]
        flex items-center
        ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
        ${className || ""}
      `}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

export default WarningButton;
